import Layout from '@/components/feature/Layout';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '韩漫网站',
      url: 'https://www.hanman.site',
      description: '汇聚众多精彩韩漫作品，免费阅读配合流畅下拉式浏览的韩国漫画平台',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@hanman.site',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebSite',
      name: '韩漫网站',
      url: 'https://www.hanman.site',
      description: '好看的韩国漫画，韩漫免费阅读漫画，下拉式韩漫在线',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.hanman.site/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '韩漫网站 - 首页',
      description: '韩漫网站汇聚众多精彩韩漫作品，免费阅读配合流畅下拉式浏览',
      url: 'https://www.hanman.site',
      isPartOf: {
        '@type': 'WebSite',
        name: '韩漫网站',
      },
      inLanguage: 'zh-CN',
    },
  ],
};

export default function HomePage() {
  return (
    <Layout>
      <SEOHead
        title="好看的韩国漫画-韩漫免费阅读漫画-下拉式韩漫在线-韩漫网站"
        description="韩漫网站汇聚众多精彩韩漫作品，免费阅读配合流畅下拉式浏览，智能加载技术确保您在各类设备上获得极致体验。好看的韩国漫画、韩漫免费阅读漫画、下拉式韩漫在线，尽在韩漫网站。"
        keywords="韩漫,韩国漫画,韩漫免费阅读,下拉式韩漫,韩漫在线,韩漫网站,好看的韩国漫画"
        canonicalUrl="https://www.hanman.site"
      />
      <SchemaOrg schema={homeSchema} />
      <HeroSection />
      <FeaturedComics />
      <CategorySection />
      <LatestUpdates />
      <FAQSection />
    </Layout>
  );
}